import { Capacitor } from "@capacitor/core";
import { gatewayConfig } from "../gatewayClient/config";
import { oidcConfig } from "../oauth/config";
import AppGroupUserDefaults from "../../plugins/appGroupUserDefaults/AppGroupUserDefaultsPlugin";
import { getLiveToken } from "../../state/rocketchatState/rocketchatUi.store";
import { getRocketChatUrl } from "../../utils";
import { chatBackend, spchatUrl } from "../rocketchat/chatBackend";
import { bs } from "../../state/bound.store";

export default function shareExtensionListener() {
  if (Capacitor.getPlatform() !== "ios") return;

  const liveToken = getLiveToken();
  const chatAuthorisationToken = liveToken?.authToken;
  const userId = liveToken?.userId;
  const organisationId = liveToken?.org;

  if (!chatAuthorisationToken || !userId || !organisationId) return;

  const chatBaseUrl = getRocketChatUrl(organisationId);

  const authorisationToken = bs().IDtoken;
  const refreshToken = bs().refreshToken;

  if (!authorisationToken || !refreshToken) return;

  const authenticationBaseUrl = oidcConfig().authority;
  const clientId = oidcConfig().client_id;
  const clientSecret = oidcConfig().client_secret;

  if (!authenticationBaseUrl || !clientId || !clientSecret) return;

  const gatewayBaseUrl = gatewayConfig().baseUrl;

  if (!gatewayBaseUrl) return;

  // spchat's route on the spchat backend: the gateway's would start a native org's stopped
  // container. Both take the Keycloak bearer the extension already sends.
  const orgQuery = `orgId=${encodeURIComponent(organisationId)}`;
  const ensureRunningUrl =
    chatBackend() === "spchat"
      ? `${spchatUrl()}/api/chat/ensureRunning?${orgQuery}`
      : `${gatewayBaseUrl}rocketchat/ensureRunning?${orgQuery}`;

  const payload = {
    chatAuthorisationToken,
    userId,
    organisationId,
    chatBaseUrl,
    authenticationBaseUrl,
    authorisationToken,
    refreshToken,
    clientId,
    clientSecret,
    gatewayBaseUrl,
    ensureRunningUrl,
  };

  AppGroupUserDefaults.set({
    key: "share-extension",
    value: JSON.stringify(payload),
  });
}
